module.exports = __webpack_public_path__ + "img/meunDetail11.01b21647.png";